export default __webpack_public_path__ + "static/indoor6-593cdc46698327a00c327ef5b1bad153.webp";